var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.$t('tour_setting_arrival_label')))]),_c('search-station',{attrs:{"callback":_vm.callback}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }